import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { ErrorsService } from '../../utils/services/errors.service';
@Injectable()
export class LoginService {

  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }

  /**login authentication by passing user credential*/
  login(data): Observable<any> {
    return this.httpService.post(`login`, data)
      .map((res: Response) => res.json())
      // .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**function handle error service */
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/common/login/login.service.ts